"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgExclamationSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.882 20.235a1.88 1.88 0 011.883 1.883A1.88 1.88 0 0111.882 24 1.88 1.88 0 0110 22.118a1.88 1.88 0 011.882-1.883zm0-20.235c.715 0 1.306.531 1.4 1.22l.012.192v13.176a1.412 1.412 0 01-2.81.192l-.013-.192V1.412c0-.78.632-1.412 1.411-1.412z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgExclamationSolid;
exports.default = _default;